import { vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cef00438"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "input-group form-label-group" }
const _hoisted_3 = ["id", "autocomplete", "placeholder"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_5 = { class: "error-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: _ctx.id,
        ref: "password-input",
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
        autocomplete: _ctx.autocomplete,
        placeholder: _ctx.placeholder,
        type: 'password',
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validatePassword && _ctx.validatePassword(...args))),
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.passwordUpdated && _ctx.passwordUpdated(...args)))
      }, null, 40, _hoisted_3), [
        [_vModelDynamic, _ctx.password]
      ]),
      _hoisted_4,
      _createElementVNode("template", null, [
        _createElementVNode("button", {
          class: "btn btn-outline secondary",
          tabindex: "-1",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.passwordToggle && _ctx.passwordToggle(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['far', _ctx.eyeIcon],
            "fixed-width": ""
          }, null, 8, ["icon"])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("p", _hoisted_5, "Enter at least 6 characters.", 512), [
      [_vShow, _ctx.showPasswordError]
    ])
  ]))
}